import styled, { css } from 'styled-components'

import { color, space, SpaceProps, spacing } from '../../../../themes'

export const Container = styled.div<SpaceProps>`
  ${space};
  display: flex;
  flex-direction: column;
`

export const CardContainer = styled.div<{ disableTopBorder?: boolean }>`
  ${({ disableTopBorder }) =>
    !disableTopBorder &&
    css`
      border-top: 1px solid ${color('gray.05')} !important;
    `}

  & > *,
  & > a > * {
    border-bottom: 1px solid ${color('gray.05')} !important;
    padding: ${spacing(3, 0)} !important;
  }
`
